
import React, { useState } from 'react'
import { ListGroup } from 'react-bootstrap'

import { useProgrammation } from '@/Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'

import ContentBlock from '../../components/ContentBlock'
import RelationsCreator from './RelationsCreator'
import RelationItem from './RelationItem'

import './Relations.scss'

const Relations = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  return (
    <ContentBlock
      title={t('PROGRAMMATION_MANAGER:SectionRelationsTitle') + ` (${itemOpened.relations.length})`}
      collapsable
      isCollapsed={!itemOpened.relations.length}
    >
      <div style={{ textAlign: 'right' }}>
        <RelationsCreator />
      </div>
      <ListGroup>
        {itemOpened.relations.map((r: any, i: number) => (
          <RelationItem key={i} item={r} />
        ))}
      </ListGroup>
    </ContentBlock>
  )
}

export default Relations